import { render, staticRenderFns } from "./CbsObjectsReport.vue?vue&type=template&id=315335d0&scoped=true"
import script from "./CbsObjectsReport.vue?vue&type=script&lang=js"
export * from "./CbsObjectsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315335d0",
  null
  
)

export default component.exports